import request from "@/utils/http"
import { cacheRequest } from "@/utils/decorator"

export function getStsToken() {
  return request.get("/sheet/oss/getStsToken")
}

export function getApp(appId, cache = false) {
  return appApi.getApp(appId, cache)
}

class AppApi {
  @cacheRequest()
  getApp(appId, cache) {
    return request.get("/users/app/get", { params: { appId } }).commonDeal()
  }
}
const appApi = new AppApi()
